import CalcMaterial from "./components/CalcMaterial/CalcMaterial";

const rootPath = process.env.PUBLIC_URL;

//  拿掉  exact 避免 LIFF 白畫面
const routes = [
  {
    path: `/`,
    component: CalcMaterial,
  },
];

export default routes;
export { rootPath };
